/**
 * Abstract class that defines a generic pool structure.
 * The class uses a pool of reusable objects to avoid the constant creation and destruction of elements.
 */
export class BasePool {
    constructor() {
        this._elements = [];
        this._warned = false;
    }
    /**
     * Retrieves an element from the pool. If no elements are available, a new one is created.
     * @returns An element of type T.
     */
    get() {
        const elements = this._elements;
        if (elements.length > 100 && !this._warned) {
            console.warn('Pool has more than 100 list items: possible memory leak.');
            this._warned = true;
        }
        return elements.length > 0 ? elements.pop() : this._createElementCallback();
    }
    /**
         * Retrieves a specified number of elements from the pool.
         * If there are not enough elements available, new elements are created
         * using the _createElementCallback method to meet the requested count.
         * @param count - The number of elements to retrieve from the pool.
         * @returns An array of elements of type T, containing the requested number of elements.
         */
    getN(count) {
        const elements = [];
        for (let i = 0; i < count; i++) {
            elements.push(this.get());
        }
        return elements;
    }
    /**
     * Releases elements back into the pool, making them available for reuse.
     * @param element - The element of type T to be released into the pool.
     */
    release(...elements) {
        this._elements.push(...elements);
    }
}
//# sourceMappingURL=BasePool.js.map